import * as swcHelpers from '@swc/helpers';
import { useEffect, useMemo } from 'react';
import { createCustomEvent } from './utils.js';

function handlePageView(pageDetails) {
    return _handlePageView.apply(this, arguments);
}
function _handlePageView() {
    _handlePageView = // Reusable function for handling page view dispatch
    swcHelpers.asyncToGenerator(function*(pageDetails) {
        const details = yield pageDetails();
        if (details !== undefined) {
            dispatchPageView(()=>Promise.resolve(details)
            );
        }
    });
    return _handlePageView.apply(this, arguments);
}
function useTrackPageView(pageDetails) {
    useEffect(()=>{
        handlePageView(pageDetails);
    }, [
        pageDetails
    ]);
}
function useDispatchTrackPageView() {
    const pageViewDispatcher = useMemo(()=>{
        return function() {
            var _ref = swcHelpers.asyncToGenerator(function*(pageDetails) {
                yield handlePageView(pageDetails);
            });
            return function(pageDetails) {
                return _ref.apply(this, arguments);
            };
        }();
    }, []);
    return pageViewDispatcher;
}
function dispatchPageView(pageDetails) {
    return _dispatchPageView.apply(this, arguments);
}
function _dispatchPageView() {
    _dispatchPageView = swcHelpers.asyncToGenerator(function*(pageDetails) {
        try {
            const details = yield pageDetails();
            if (details !== undefined) {
                const event = createCustomEvent(details);
                globalThis.dispatchEvent(event);
            }
        } catch (error) {
            console.error('Error dispatching page view event:', error);
        }
    });
    return _dispatchPageView.apply(this, arguments);
}

export { useDispatchTrackPageView, useTrackPageView };
//# sourceMappingURL=use-track-page-view.js.map
